import { render, staticRenderFns } from "./GroupManagementButton.vue?vue&type=template&id=1f6f250a&scoped=true&"
import script from "./GroupManagementButton.vue?vue&type=script&lang=js&"
export * from "./GroupManagementButton.vue?vue&type=script&lang=js&"
import style0 from "./GroupManagementButton.vue?vue&type=style&index=0&id=1f6f250a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f250a",
  null
  
)

export default component.exports